export default __webpack_public_path__ + "images/463d6fba4d3dee2bcd01ecfcd342dd71-consent-texto.svg";